export default [
  {
    key: 'increasement',
    // sortable: true,
    // sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px text-left',
    tdClass: 'text-left',
  },
  {
    thClass: 'text-left',
    tdClass: 'text-left',
    key: 'projectName',
    label: 'breadcrumb.project',
  },
  {
    key: 'enterpriseName',
    label: 'general.enterprise_name',
  },
  {
    key: 'orderId',
    label: 'general.order_id',
  },
  // {
  //   key: 'buildingName',
  //   label: 'general.building_name',
  // },
  // {
  //   key: 'roomName',
  //   label: 'general.room_name',
  // },
  {
    key: 'origin',
    label: 'general.origin',
  },
  {
    key: 'serviceCategory',
    label: 'breadcrumb.serviceCategory',
  },
  {
    key: 'serviceType',
    label: 'breadcrumb.serviceType',
  },
  {
    key: 'serviceSubType',
    label: 'breadcrumb.serviceSubType',
  },
  // {
  //   key: 'departmentName',
  //   label: 'field.departmentName',
  // },
  {
    // stickyColumn: true,
    // variant: 'light',
    thClass: 'text-left',
    tdClass: 'text-left',
    key: 'shortenName',
    label: 'field.serviceName',
  },
  {
    key: 'servicePrice',
    label: 'field.servicePrice',
  },
  {
    key: 'orderInitiator',
    label: 'general.order_initiator',
  },
  {
    key: 'initiateTime',
    label: 'general.initiate_time',
  },
  // {
  //   key: 'assignedOperator',
  //   label: 'field.assignee',
  // },
  // {
  //   key: 'chatAgentName',
  //   label: 'field.chatAgent',
  // },
  {
    key: 'assignedOperator',
    label: 'field.operator',
  },
  {
    key: 'acceptedAt',
    label: 'general.order_received_time',
  },
  {
    key: 'completedAt',
    label: 'general.completion_time',
  },
  {
    key: 'status',
    label: 'field.status',
    width: 160,
    tdClass: 'sticky-column sticky-service-status',
    thClass: 'sticky-header',
    thStyle: {
      right: '310px',
      background: 'white !important',
    },
  },
  {
    key: 'actions',
    label: 'general.action',
    width: 310,
    tdClass: 'sticky-column sticky-service-actions',
    thClass: 'sticky-header sticky-header-actions',
    thStyle: {
      right: '0px',
      background: 'white !important',
    },
  },
]
